import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import * as utils from "common/utils";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import Alert from "components/Alert";
import { confirm } from "containers/App/_actions";
import { revokeFarmAccess, revokePublicationAccess, setPaymentNotification } from "./_actions";
import ActionLink from "components/ActionLink";
import Toggle from "react-toggle";

const FarmAccessList = (props) => {
    const { online, farm, access, authContext, confirm, refData, isPublicationAccess, setPaymentNotification } = props;

    const _revokeAccess = (farmAccess) => {
        const isMyAccess = farmAccess.accountId === authContext.accountId;
        const confirmMsg = isMyAccess ? "Are you sure you want to revoke your own access?" : "Are you sure you want to revoke this access?";

        if (isPublicationAccess) confirm(confirmMsg, () => props.revokePublicationAccess(farm.id, farmAccess, isMyAccess), false);
        else confirm(confirmMsg, () => props.revokeFarmAccess(farm.id, farmAccess, isMyAccess), false);
    };

    const noPaymentNotifcations = !access.some((a) => a.paymentNotification);
    const canManageAccess = utils.canManageAccess(farm);
    const isOwner = utils.isOwner(farm);

    return (
        <Panel title={isPublicationAccess ? "Users with publication access" : "Organisations with farm access"} midBlue>
            {isPublicationAccess && <Alert type="info" text="The list of users who can act as your agent for publications published to you for this farm." />}
            {!isPublicationAccess && <Alert type="info" text="The list of organisations that you have granted access for this farm." />}
            <PanelBody>
                {access.length > 0 && (
                    <div className="Table">
                        <table>
                            <thead>
                                <tr>
                                    {!isPublicationAccess && <th>Organisation</th>}
                                    {isPublicationAccess && <th>User</th>}
                                    <th>Date</th>
                                    <th>Role</th>
                                    {!isPublicationAccess && <th className="th--shrink">Subscription reminders</th>}
                                    {online && <th className="th--shrink"></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {access
                                    .sort((a, b) => (a.accountName > b.accountName ? 1 : -1))
                                    .filter((a) => (isPublicationAccess ? a.role === "PublicationAgent" : a.role !== "PublicationAgent"))
                                    .map((farmAccess) => {
                                        const key = `${farmAccess.accountId}-${farmAccess.role}`;
                                        const isOwnerAccess = farmAccess.role === "Owner";
                                        return (
                                            <tr key={key} className={isOwnerAccess ? "u-textBold is-selected" : ""}>
                                                {!isPublicationAccess && <td>{farmAccess.accountName}</td>}
                                                {isPublicationAccess && <td>{farmAccess.email}</td>}
                                                <td>{utils.dateOnly(farmAccess.createdOn)}</td>
                                                <td>{utils.valueToText(refData.farmRoles, farmAccess.role)}</td>
                                                {!isPublicationAccess && <td className="td--shrink u-textCenter">{canManageAccess && <>{farmAccess.role === "Owner" && noPaymentNotifcations ? <div>On - Default</div> : <Toggle defaultChecked={farmAccess.paymentNotification} onClick={(e) => setPaymentNotification(farm.id, farmAccess.accountId, e.target.checked)} className="My-farm-toggle" />}</>}</td>}
                                                {online && (
                                                    <td>
                                                        {isPublicationAccess ? (
                                                            <div className="u-flex">
                                                                {"PublicationAgent" === farmAccess.role && (
                                                                    <ActionLink className="IconLink--cross-circle u-ml-sm" id={`revoke-${key}`} onClick={(e) => _revokeAccess(farmAccess)}>
                                                                        Revoke
                                                                    </ActionLink>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="u-flex">
                                                                {(isOwner || (canManageAccess && !isOwnerAccess)) && !["Publication", "PublicationAgent"].includes(farmAccess.role) && (
                                                                    <ActionLink className="IconLink--cross-circle u-ml-sm" id={`revoke-${key}`} onClick={(e) => _revokeAccess(farmAccess)}>
                                                                        Revoke
                                                                    </ActionLink>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                )}
            </PanelBody>
        </Panel>
    );
};

export default compose(withAppContext, withActions({ confirm, revokeFarmAccess, revokePublicationAccess, setPaymentNotification }))(FarmAccessList);
